import type { ElementType, PropsWithChildren } from 'react';
import React from 'react';
import * as styles from '../css/lead-text.css';

interface Props {
    component?: ElementType;
}

const LeadText = ({ component: Component = 'p', ...rest }: PropsWithChildren<Props>) => (
    <Component className={styles.root} {...rest} />
);

export default LeadText;
